<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams">
        <!-- 国家 -->
        <el-form-item label="区域">
          <el-select
            filterable
            v-model="queryParams.areaName"
            placeholder="请选择区域"
            clearable
            @change="changeArea"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.areaName"
              :value="item.areaName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select
            filterable
            v-model="queryParams.countryName"
            placeholder="请选择国家"
            clearable
          >
            <el-option
              v-for="(item, index) in countryList.filter(item => {
                return (
                  !queryParams.areaName || item.areaName == queryParams.areaName
                );
              })"
              :key="index"
              :label="item.countryName"
              :value="item.countryName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年份 -->
        <el-form-item label="年份">
          <el-date-picker
            type="year"
            value-format="yyyy"
            v-model="queryParams.years"
            placeholder="请选择"
            :clearable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 操作 -->
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="doSearch"
            >查询</el-button
          >
          <el-button type="primary" size="small" @click="handleResetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="loading" v-if="baseInfo">
      <div class="baseInfo">
        <div>{{ baseInfo.countryName }}</div>
        <div>人口: {{ baseInfo.population }} 万人</div>
        <div>人均GDP: {{ baseInfo.gdp }} 美元</div>
      </div>
      <car-sale-total ref="carSaleTotal" />
      <car-model-sale-total ref="carModelSaleTotal" />
      <compete-brand ref="competeBrand" />
    </div>
  </div>
</template>
<script>
import {
  getAreaCountryListApi,
  getSaleTotalStatisApi
} from "@/api/saleTaskCollection";
import * as moment from "moment";
import CarSaleTotal from "./components/carSaleTotal.vue";
import CarModelSaleTotal from "./components/carModelSaleTotal.vue";
import CompeteBrand from "./components/competeBrand.vue";

export default {
  components: {
    CarSaleTotal,
    CarModelSaleTotal,
    CompeteBrand
  },
  data() {
    return {
      // 区域
      areaList: [],
      // 国家
      countryList: [],
      // 搜索条件
      queryParams: {
        areaName: "", // 区域
        countryName: "", // 国家
        years: moment().format("YYYY") // 年份
      },
      loading: false, // 加载中
      baseInfo: null, // 基础信息
      pickerOptions: {
        disabledDate(time) {
          const preYear = 2021;
          const afterYear = new Date().getFullYear();
          return time.getFullYear() > afterYear || time.getFullYear() < preYear;
        }
      }
    };
  },
  created() {
    // 获取区域国家
    this.getAreaCountryList();
  },
  methods: {
    // 获取地区国家列表
    async getAreaCountryList() {
      const res = await getAreaCountryListApi();
      this.areaList = res.data.saleAreaList || [];
      this.countryList = res.data.saleCountryList || [];
    },
    // 区域改变
    changeArea() {
      this.queryParams.countryName = "";
    },
    // 搜索
    doSearch() {
      this.getStatisData();
    },
    // 重置
    handleResetQuery() {
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.doSearch();
    },
    // 获取统计数据
    async getStatisData() {
      try {
        this.loading = true;
        const res = await getSaleTotalStatisApi(this.queryParams);
        if (res.status == 0) {
        } else {
          this.$DonMessage.error(res.message);
        }
        this.baseInfo = res.data?.saleInformation;
        if (this.baseInfo) {
          this.$nextTick(() => {
            this.$refs.carSaleTotal.getStatisData(res.data?.saleCarTotal);
            this.$refs.carModelSaleTotal.getStatisData(
              res.data?.saleCarTypeTotal
            );
            this.$refs.competeBrand.init(this.queryParams);
          });
        }
      } catch (error) {}
      this.loading = false;
    }
  }
};
</script>
<style scoped lang="scss">
.filter-container {
  padding: 30px 20px 0 20px;
  border-bottom: 5px solid #efefef;
  ::v-deep .el-input {
    width: 150px;
  }
}
.baseInfo {
  padding: 20px 40px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  div {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
}
</style>
